import { useContext } from 'react';
import { MenuContext } from '../../context/MenuContext';
import { ReportContext } from '../../context/ReportContext';
import ReportsHeader from '../Header/ReportsHeader';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import ErrorCard from '../Cards/ErrorCard';

const ReportsPane = () => {
    const { selectedMenuItem } = useContext(MenuContext);
    const { selectedReport, errorText, hasMadeFirstRequest, inFlight, noReportsAvailable } =
        useContext(ReportContext);

    const PageComponent = selectedReport?.pageComponent;

    if (!PageComponent) {
        return <div>Report not found</div>;
    }

    const Display = () => {
        if (errorText) {
            return <ErrorCard>{errorText}</ErrorCard>;
        }

        if (noReportsAvailable) {
            return null; // Message is shown in header; suppress page content
        }

        if (inFlight) {
            return <div>Loading...</div>;
        }

        if (!hasMadeFirstRequest && !noReportsAvailable) {
            return <div>Configure the report parameters above and click Run</div>;
        }

        return <PageComponent />;
    };

    return (
        <div className="bg-white rounded-md shadow-md m-4 p-6">
            <h1 className="text-xl font-bold mb-4">{selectedMenuItem.name}</h1>
            {selectedMenuItem.isCustom ? (
                <PageComponent />
            ) : (
                <>
                    <ReportsHeader />
                    <Display />
                </>
            )}
        </div>
    );
};

export default ReportsPane;
